import { colors, fontSizes } from '../../../../Components/consts'
import { styled } from '@mui/system'

export type StyleProps = {
  color: string
  active?: boolean
  disabled?: boolean
}

export const LinkStyle = styled('span')<StyleProps>(
  ({ theme }) => ({
    whiteSpace: 'nowrap',
    margin: theme.spacing(0, 1),
    padding: theme.spacing(0.25, 0.5),
    borderBottom: 'none',
    textDecoration: 'none',
    color: colors.text,
    '& a': {
      textDecoration: 'none',
      color: colors.text,
    },
  })
)

export const SocialIc = styled('a')(({ theme }) => ({
  '& svg': {
    marginBottom: -3,
    width: 18,
    height: 18,

    [theme.breakpoints.down('xs')]: {
      width: 16,
      height: 16,
      marginBottom: -3,
    },
  },
  marginLeft: theme.spacing(2),
}))

export const LinkBarCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
  '& .up': {
    flexGrow: 0,
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
    '& .photo': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& svg': {
        width: 22,
        height: 22,
        fill: colors.lightGrey,
      },
      '& img': {
        width: 64,
        height: 64,
        margin: theme.spacing(0, 2),
      },
    },
    '& .nameCon': {
      display: 'flex',
      flexDirection: 'column',
      '& .name': {
        textAlign: 'center',
        fontSize: fontSizes.large,
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
          fontSize: `min(8vw, ${fontSizes.large}px)`,
        },
      },
      '& .teamCon': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        [theme.breakpoints.down('xs')]: {
          justifyContent: 'center',
        },
        '& .team': {
          fontSize: fontSizes.small,
          fontWeight: 'normal',
          [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
          },
        },
      },
    },
    '& .favMargin': {
      marginTop: theme.spacing(0.5),
      marginLeft: theme.spacing(1),
    },
  },
  '& .socials': {
    flexGrow: 0,
    fontSize: fontSizes.medium,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2, 1),
      fontSize: fontSizes.medium,
    },
  },
}))

export const TeamCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  [theme.breakpoints.down('xs')]: {
    justifyContent: 'center',
  },
  '& .team': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
    '& a': {
      textDecoration: 'none',
      color: colors.text,
      cursor: 'pointer',
      '& .teamLink': {
        fontSize: fontSizes.small,
        margin: theme.spacing(0, 1),
        [theme.breakpoints.down('xs')]: {
          textAlign: 'center',
        },
      },
    },
    '& p': {
      fontSize: fontSizes.small,
      margin: theme.spacing(0, 1),
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
      },
    },
  },
}))

export const FlagCon = styled('div')(({ theme }) => ({
  display: 'inline-block',
  width: 25,
  height: 22,
  marginLeft: theme.spacing(1),
  '& .flag': {
    width: `100%`,
    height: `80%`,
    objectFit: 'contain',
  },
}))
